import { apiHelper, PromiseHandler } from "../redux/apiHelper";

const getCoupons = (data) =>
  PromiseHandler(apiHelper("post", `/api/admin/coupon/get`, data));
const getCouponById = (id) =>
  PromiseHandler(apiHelper("get", `/api/admin/coupon/get/${id}`));
const addCoupon = (data) =>
  PromiseHandler(apiHelper("post", `/api/admin/coupon/add`, data));
const updateCoupon = (id, data) =>
  PromiseHandler(apiHelper("post", `/api/admin/coupon/edit/${id}`, data));
const deleteCouponById = (id) =>
  PromiseHandler(apiHelper("post", `/api/admin/coupon/delete/${id}`));

export {
  getCoupons,
  getCouponById,
  addCoupon,
  updateCoupon,
  deleteCouponById,
};
